module.exports = __webpack_public_path__ + "img/num04.71357d75.png";